
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/funding/View",
      function () {
        return require("private-next-pages/funding/View.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/funding/View"])
      });
    }
  